import React from 'react'

const PaginationNumbering = ({ currentTab }) => <div className='pagination-num'><span>{currentTab}</span> / 8</div>

export default PaginationNumbering